export const CHECK_NON_FORFAIT_TOKEN_FAILURE = 'CHECK_NON_FORFAIT_TOKEN_FAILURE';
export const CHECK_NON_FORFAIT_TOKEN_SUCCESS = 'CHECK_NON_FORFAIT_TOKEN_SUCCESS';
export const STOP_CHECKOUT_LOADING = 'STOP_CHECKOUT_LOADING';
export const SAVE_QUERY_PARAMS ='SAVE_QUERY_PARAMS';


// WEBPACK FOOTER //
// ./src/workflow/checkout/types.js